import React from 'react'

export const Footer = () => {
  return (
    <footer className='footer'>
        Portafolio Michael Cuadros &copy; Master en React 2023
    </footer>
  )
}
